import { $generateHtmlFromNodes } from '@lexical/html';
import { getStyleObjectFromCSS } from '@lexical/selection';
import { $getRoot, LexicalEditor } from 'lexical';
import { FontPluginStyle } from './Plugins/FontPlugin/style';

export const generateHtml = (editor: LexicalEditor | null): string => {
  if (editor) {
    return editor.read(() => {
      return $generateHtmlFromNodes(editor, null);
    });
  }

  return '';
};

export const getFontNames = (editor: LexicalEditor): Set<string> => (
  editor.read(() => {
    return $getRoot().getAllTextNodes().reduce((acc, item) => {
      const styles = item.getStyle();
      const styleObject = getStyleObjectFromCSS(styles);
      const fontName = styleObject[FontPluginStyle.BRAND_FONT_NAME] || styleObject[FontPluginStyle.FONT_FAMILY];
      if (fontName) {
        acc.add(fontName);
      }

      return acc;
    }, new Set<string>());
  })
);
